(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sticker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements && customElements.get('sticker-block')) return;

    var VISIBLE = 'visible';
    var SKIP = {
      'STICKER-BLOCK': 1, SCRIPT: 1, STYLE: 1, LINK: 1, TEMPLATE: 1, NOSCRIPT: 1,
    };

    /* The union of the laid-out boxes inside `root`.

       A wrapper whose children are all floated or absolutely positioned reports a
       height of 0 while keeping its full width. Percentages on `left` still work,
       percentages on `top` all collapse to 0, and the vertical control looks
       dead. When that happens we measure the content ourselves instead of
       trusting the wrapper's own height. */
    function contentExtent(root) {
      var top = Infinity;
      var bottom = -Infinity;
      var found = false;

      (function walk(node) {
        for (var i = 0; i < node.children.length; i++) {
          var child = node.children[i];
          if (SKIP[child.tagName]) continue;

          var rect = child.getBoundingClientRect();

          if (rect.height > 0) {
            found = true;
            if (rect.top < top) top = rect.top;
            if (rect.bottom > bottom) bottom = rect.bottom;
          } else {
            walk(child);
          }
        }
      })(root);

      return found ? { top: top, height: bottom - top } : null;
    }

    class StickerBlock extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-anchored')) return;
        this.attach();
      }

      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
      }

      /* Find the element the sticker should be positioned against. */
      resolveAnchor() {
        var mode = this.dataset.anchor || 'section';

        if (mode === 'parent') return this.parentElement;

        if (mode === 'custom' && this.dataset.anchorSelector) {
          try {
            return this.closest(this.dataset.anchorSelector) || this.parentElement;
          } catch (e) {
            return this.parentElement;
          }
        }

        return this.closest('.shopify-section') || this.parentElement;
      }

      attach() {
        var anchor = this.resolveAnchor();
        if (!anchor) return;

        /* An absolutely positioned element resolves against its NEAREST
           positioned ancestor, so a positioned wrapper between the sticker and
           the chosen anchor would silently hijack it. Moving the sticker into the
           anchor makes the merchant's choice authoritative, and drops any
           intermediate overflow or transform on the way out. */
        if (this.parentElement !== anchor && !this.contains(anchor)) {
          this.setAttribute('data-anchored', '');
          anchor.appendChild(this);
        }

        var anchorStyles = getComputedStyle(anchor);

        /* Absolute positioning needs a positioned ancestor to measure against. */
        if (anchorStyles.position === 'static') {
          anchor.style.position = 'relative';
        }

        /* z-index only competes inside the same stacking context. Lifting the
           anchor lets a sticker overlap the sections above and below it. With
           several stickers in one section the highest request wins, and a z-index
           the theme set itself is never overwritten. */
        if (this.dataset.raiseAnchor === 'true') {
          var owned = anchor.hasAttribute('data-sticker-z');

          if (anchorStyles.zIndex === 'auto' || owned) {
            var want = parseInt(getComputedStyle(this).getPropertyValue('--sticker-z'), 10);
            var held = owned ? parseInt(anchor.getAttribute('data-sticker-z'), 10) : -1;

            if (!isNaN(want) && want > held) {
              anchor.style.zIndex = want;
              anchor.setAttribute('data-sticker-z', want);
            }
          }
        }

        if (this.dataset.releaseOverflow === 'true') {
          this.releaseOverflow(anchor);
        }

        if (this.dataset.clipPage === 'true') {
          document.documentElement.classList.add('sticker-clip-x');
        }

        this._anchor = anchor;
        this.calibrate();
        this.watch();

        this.setAttribute('data-anchored', '');
      }

      /* Percentages on `top` are measured against the anchor's own height. If the
         anchor has none, publish a measured pixel range instead and let the CSS
         switch to it via [data-measured]. */
      calibrate() {
        var anchor = this._anchor;
        if (!anchor) return;

        /* Width-relative placement never needs measuring — it is already
           independent of the anchor's height. */
        if (this.dataset.vunit === 'width' || anchor.clientHeight > 0) {
          this.removeAttribute('data-measured');
          this.style.removeProperty('--sticker-anchor-top');
          this.style.removeProperty('--sticker-anchor-height');
          return;
        }

        var extent = contentExtent(anchor);
        if (!extent) return;

        var offset = extent.top - anchor.getBoundingClientRect().top;

        this.style.setProperty('--sticker-anchor-top', Math.round(offset) + 'px');
        this.style.setProperty('--sticker-anchor-height', Math.round(extent.height) + 'px');
        this.setAttribute('data-measured', '');
      }

      /* Keep the measured range fresh as the section reflows or images land. */
      watch() {
        if (this._observer || typeof ResizeObserver === 'undefined') return;

        var self = this;
        this._observer = new ResizeObserver(function () {
          self.calibrate();
        });

        this._observer.observe(this._anchor);

        for (var i = 0; i < this._anchor.children.length; i++) {
          var child = this._anchor.children[i];
          if (child.tagName !== 'STICKER-BLOCK') this._observer.observe(child);
        }
      }

      /* Clear clipping between the sticker and its anchor so it can hang over the
         edge. Genuine scroll containers (carousels, marquees) are skipped. */
      releaseOverflow(stopAt) {
        var el = this.parentElement;

        while (el) {
          var styles = getComputedStyle(el);

          if (styles.overflowX !== VISIBLE || styles.overflowY !== VISIBLE) {
            var scrolls =
              el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
            if (!scrolls) el.style.overflow = VISIBLE;
          }

          if (el === stopAt) break;
          el = el.parentElement;
        }
      }
    }

    customElements.define('sticker-block', StickerBlock);
  })();
  } catch(e) { console.error(e); }
})();

})();
